//third party

import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { ComponentsModule } from "../components/components.module";
import { MaterialModule } from "../material.module";
import { CustomisableReportsComponent } from "./CustomisableReports/customisablereports.component";
import { DashboardStandard1Component } from "./DashboardStandard1/dashboardstandard1.component";
import { ListPageComponent } from "./ListPage/listpage.component";
import { MissedCallsReportModule } from "./MissedCallsReport/missed-calls-report.module";


import { CalendarModule } from 'primeng/calendar';
import { GridsterModule } from "angular-gridster2";
import { DirectivesModule } from "../directives/directives.module";

@NgModule({
  exports: [

    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    NgxChartsModule,
    ComponentsModule,
    //MissedCallsReportModule
    DashboardStandard1Component,
    ListPageComponent,
    CustomisableReportsComponent

  ],
  declarations: [
    DashboardStandard1Component,
    ListPageComponent,
    CustomisableReportsComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    NgxChartsModule,
    ComponentsModule,
    MissedCallsReportModule,
    CalendarModule,
    GridsterModule,


    DirectivesModule
  ]
})
export class PagesModule { }
